export function parseFitment(value) {
  if (Array.isArray(value)) return value.map((s) => String(s).trim()).filter(Boolean);
  if (value == null) return [];
  return String(value).split("/").map((s) => s.trim()).filter(Boolean);
}

export function fitmentToText(arr) {
  return (Array.isArray(arr) ? arr : []).join(" / ");
}
